
<template>
  <tbody>
    <TableRow
      v-for="(rowData, index) in rowsData"
      :key="index"
      :rownumber="index"
      :row-data="rowData"
      :row-action="rowAction"
      :allow-selection="allowSelection"
      :columns="columns"
      :bg-color="rowData.bgColor"
      :text-color="rowData.textColor"
    >
      <slot />
    </TableRow>
    <template v-if="$slots['expanded-row']">
      <slot
        name="expanded-row"
        :row="rowsData"
      />
    </template>
  </tbody>
</template>

<script>
import TableRow from './TableRow.vue';

export default {
  name: 'TableBody',
  components: {
    TableRow,
  },
  props: {
    allRowsSelected: { type: Boolean, required: true },
    allowSelection: { type: Boolean, default: false },
    rowAction: { type: Function, default: null },
    rowsData: { type: Array, default: () => [] },
    columns: { type: Array, default: () => [] },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    allRowsSelected(newVal) {
      this.rowsData.forEach((item) => {
        item.selected = newVal;
      });
    },
  },
  methods: {
  },
};
</script>
